import { TFunction } from "i18next";
import { AllocationRequestStatus } from "Modules/allocationRequest/interfaces/allocationRequest.interface";
import { Document, Types } from "mongoose";

export type NotificationType = 'INFO' | 'WARNING' | 'ERROR' | 'SUCCESS';
export type NotificationResult = 'SUCCESS' | 'FAILURE' | 'PENDING';
export type NotificationStatus = 'PENDING' | 'APPROVED' | 'REJECTED';


export interface INotification extends Document {
    from?: Types.ObjectId,
    to: Types.ObjectId,
    title: string;
    type: NotificationType;
    message: string
    isRead: boolean;
    updatedAt?: Date
    createdAt?: Date;
    isDeleted?: boolean;
    result?: NotificationResult;
    fullName?: string;
    profileImage?: {
        _id: string;
        filename: string;
        url: string;
    } | null;
}


export interface NotificationData {
    from?: Types.ObjectId,
    to: Types.ObjectId | Types.ObjectId[];
    entityData: any;

    eventType: string;
    title: string;
    type: NotificationType
}

export interface CreateNotificationParams {
    from?: Types.ObjectId;
    to: Types.ObjectId;
    title: string;
    message: string;
    type?: NotificationType
    status?: AllocationRequestStatus;
    result?: NotificationResult;
    fullName?: string;
    profileImage?: Types.ObjectId | null;
    roleName: string;
}


export type NotificationModule = 'labourManagement' | 'userManagement' | 'allocationRequest' | 'availability' | 'jobManagement' | 'chat'
export type NotificationAction<T extends NotificationModule> = string;

export interface NotificationConfig {
    eventType: string;
    title: string;
    type: NotificationType;
    recipient: 'admin' | 'user' | 'both';
    messages: {
        admin?: string;
        user?: string;
        superAdmin?: string;
        generic?: string;
        staff?: string
    };
    module: NotificationModule
    action: string
}

export const getNotificationMessages = (t: TFunction, module: NotificationModule, action: string): NotificationConfig | undefined => {
    const baseConfig = t(`Notification.${module}.${action}`, { returnObjects: true }) as Omit<NotificationConfig, 'module' | 'action'> | undefined;
    if (!baseConfig) return undefined;
    return {
        ...baseConfig,
        module,
        action
    };
};